(function ($, DrupalModernizr, Drupal, drupalSettings) {
Drupal.rmcc = Drupal.rmcc || {};
'use strict';

/**
 * Behavior for accordion slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccAccordionSLice = {
    attach: function attach(context, settings) {
      once('rmccAccordionSLiceBehavior', '.paragraph--type--accordion-slice', context).forEach(function (elem) {

        var $button = $('.paragraph--title', elem),
            $panel = $('.field--type-text-long', elem);

        $button.attr('tabIndex', 0);
        $panel.hide();

        // On click event.
        $button.on('click', function (e) {
          $(e.currentTarget).parent().toggleClass('open');
          $(e.currentTarget).next().slideToggle();
        });

        // On press of enter key event.
        $button.keyup(function (e) {
          if (e.keyCode == 13) {
            $(e.currentTarget).parent().toggleClass('open');
            $(e.currentTarget).next().slideToggle();
          }
        });
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 * Behavior for event sign up button
 *
 * Sign up button is a link to webform that we want to duplicate in event details
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccBreadcrumbs = {
    attach: function attach(context, settings) {
      once('rmccBreadcrumbsBehavior', '.breadcrumb .has-menu', context).forEach(function (elem) {
        $(elem).on('click', function (e) {
          $('.breadcrumb-menu').toggle(300);
          $('.breadcrumb').toggleClass('open');
        });
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 *
 */
(function ($) {
  Drupal.behaviors.rmccCalTree = {
    attach: function attach(context, settings) {
      if (!$('.js-cal-tree').length) {
        return false;
      }
      this.funkifyCursor(context, settings);
      this.toggleCalResults(context, settings);
      this.searchKeyPress(context, settings);

      var $singleResult = $('.single-result', context);
      if ($singleResult.length > 0) {
        var $starName = $singleResult.text();

        if ($('.personal-message', context).length > 0) {
          var isStarMessage = true;
          var $starMessage = $('.personal-message', context).text();
        }

        $('.cal-tree__tree').removeClass('found');
        $('.found .cal-tree__tree-wrapper').removeClass('sparkle');
        $('.cal-tree__star-found').removeClass('found');
        $('.found-star-alert').removeClass('found');
        $('.cal-tree__star-message').removeClass('found').empty();

        window.setTimeout(function () {
          $('.cal-tree__more-results').removeClass('show');

          // Star found
          $('.found-star-alert').addClass('found');
          window.setTimeout(function () {
            $('.js-cal-tree').addClass('found');
            $('.cal-tree__tree').addClass('found');
          }, 200);
          window.setTimeout(function () {
            $('.cal-tree__star-found').addClass('found').find('span').empty().text($starName);
            if (isStarMessage) {
              $('.cal-tree__star-message').addClass('found').text($starMessage);
            }
          }, 1500);
        });
        $('html, body').animate({
          scrollTop: $('.cal-tree__star-found').offset().top - 100
        }, 500);
      }
      $('.js-toggle-star-found').on('click', function (e) {
        var $starName = $(e.currentTarget).text();
        var $starId = $(e.currentTarget).attr('id');
        e.preventDefault();
        $('#edit-search', context).val($starName);
        $('.search-input-id', context).val($starId);
        $('#edit-submit', context).trigger('mousedown');
      });
    },


    toggleCalResults: function toggleCalResults(context) {
      var $toggleButton = $('.js-toggle-cal-results', context);
      var $moreResults = $('.cal-tree__more-results');

      $toggleButton.on('click', function (e) {
        e.preventDefault();
        $moreResults.addClass('show');
        $('html, body').animate({
          scrollTop: $moreResults.offset().top
        }, 1000);
      });

      var $toggleReset = $('.js-cal-tree-reset', context);
      $toggleReset.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('.cal-tree__form').offset().top
        }, 500, function () {
          $moreResults.removeClass('show');
        });
      });
    },

    funkifyCursor: function funkifyCursor(context) {

      var $calTree = $('.js-cal-tree', context);

      if (!$calTree.length) {
        return false;
      }

      var starTrail = {};

      starTrail.size = 10;
      starTrail.jitter = 50;
      starTrail.zindex = 5;
      starTrail.life = 1000;

      $calTree.on('mousemove', function (e) {
        var animate = function animate(i) {
          var j = (1 - i) * starTrail.jitter;
          var star = document.createElement('div');
          var size = Math.ceil(Math.random() * starTrail.size * i);
          var sizepx = size + 'px';
          $(star).css({
            "position": 'fixed',
            "top": e.clientY + Math.round((Math.random() - 0.5) * j - size / 2) + 'px',
            "left": e.clientX + Math.round((Math.random() - 0.5) * j - size / 2) + 'px',
            "width": sizepx,
            "height": sizepx,
            "color": 'white',
            "font-size": 12 + 'px',
            "opacity": Math.random() * 0.95,
            "pointerEvents": 'none',
            "zIndex": starTrail.zindex + Math.round(5 * (Math.random() - 0.5))
          }).text('☆');
          $('body').append(star);
          window.setTimeout(function () {
            document.body.removeChild(star);
          }, Math.round(Math.random() * i * starTrail.life));
        };
        for (var i = 0.2; i <= 1.0; i += 2) {
          animate(i);
        }
      });
    },

    searchKeyPress: function searchKeyPress(context) {
      $('#edit-search', context).keypress(function (e) {
        if (e.which == 13) {
          $('#edit-submit', context).mousedown();
          e.preventDefault();
        }
      });
    }
  };
})(jQuery);
'use strict';

/**
 * Behavior for Celebrate Life form
 */
(function (Drupal, $) {
  Drupal.behaviors.celebrateLife = {
    attach: function attach(context) {
      var $inputAmount = $('#edit-amount', context);
      var $selectStars = $('#edit-more-names', context);
      var $starHome = $('#edit-decoration-star', context);
      Drupal.behaviors.celebrateLife.stars = 0;
      Drupal.behaviors.celebrateLife.homeStars = 0;
      Drupal.behaviors.celebrateLife.totalAmout = 20;

      $selectStars.on('change', function () {
        Drupal.behaviors.celebrateLife.stars = 20 * $selectStars.val();
        Drupal.behaviors.celebrateLife.totalAmout = 20 + Drupal.behaviors.celebrateLife.stars + Drupal.behaviors.celebrateLife.homeStars;
        $inputAmount.val(Drupal.behaviors.celebrateLife.totalAmout);
      });
      $starHome.on('change', function () {
        Drupal.behaviors.celebrateLife.homeStars = 5 * $starHome.val();
        Drupal.behaviors.celebrateLife.totalAmout = 20 + Drupal.behaviors.celebrateLife.stars + Drupal.behaviors.celebrateLife.homeStars;
        $inputAmount.val(Drupal.behaviors.celebrateLife.totalAmout);
      });
    }
  };
})(Drupal, jQuery);
'use strict';

/**
 * Behavior for chart accordion slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccChartAccordionSLice = {
    attach: function attach(context, settings) {
      once('rmccChartAccordionSLice', '.paragraph--type--chart-accordion-slice', context).forEach(function (elem) {

        var $button = $('.paragraph--title', $(elem)),
            $panel = $('.field--type-text-long', $(elem));

        $button.attr('tabIndex', 0);
        $panel.hide();

        // On click event.
        $button.on('click', function (e) {
          $(e.currentTarget).parent().toggleClass('open');
          $(e.currentTarget).next().slideToggle();
        });

        // On press of enter key event.
        $button.keyup(function (e) {
          if (e.keyCode == 13) {
            $(e.currentTarget).parent().toggleClass('open');
            $(e.currentTarget).next().slideToggle();
          }
        });
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

(function (Drupal, $) {
  Drupal.behaviors.dedicateRoses = {
    attach: function attach(context) {
      var $helpText = $('#edit-amount--description', context);
      var $additionalRosesSelect = $('#edit-do-you-want-to-dedicate-additional-roses-', context);

      $additionalRosesSelect.change(function () {
        var totalRoses = $additionalRosesSelect.val();
        Drupal.behaviors.dedicateRoses.changeHelpText($helpText, totalRoses);
      });
    },

    changeHelpText: function changeHelpText($helpText, totalRoses) {
      if (totalRoses > 0) {
        var numberRoses = parseInt(totalRoses) + 1;
        var suggestedValue = numberRoses * 10;
        $helpText.text('We suggest a minimum donation of £' + suggestedValue + ' to dedicate ' + numberRoses + ' roses');
      } else {
        $helpText.text('We suggest a minimum donation of £10 to dedicate a rose');
      }
    }
  };
})(Drupal, jQuery);
'use strict';

(function ($, Drupal, drupalSettings) {

    $(document).ready(function () {
        // Create donation tabs
        $('#donate--tabs').tabs();

        // Prepopulate amount on donate--button click
        $('.donate--button').click(function (event) {
            var amount = $(this).find('.donate--amount > span').text().trim();
            $(this).closest('.donation--tab').find('input[name="amount"]').val(parseFloat(amount));
            // Submit form
            var $form = $(this).closest('.donation--tab').find('.donation-field-form');
            $form.get(0).submit();
        });
    }); // document ready.

})(jQuery, Drupal, drupalSettings);
'use strict';

/**
 * Behavior for event sign up button
 *
 * Sign up button is a link to webform that we want to duplicate in event details
 */
/*Drupal.behaviors.rmccSignUp = {
  attach(context, settings) {
    once('rmccGallerySLiceBehavior', '.node--type-event .field--name-webform', context).forEach((elem) => {

      $('.event-details').addClass('with-sign-up');
      $('> div', '.event-details').append('<div class="layout__container-3" />');
      $('.layout__container-3', '.event-details').html($(elem).html());

    });
  }
};*/

(function (Drupal, $, once) {
  Drupal.behaviors.rmccEventForm = {
    attach: function attach(context, settings) {
      once('rmccEventForm', '.node--type-event', context).forEach(function (elem) {

        var $button = $('.event--button', $(elem)),
            $panel = $('.webform--wrapper', $(elem));

        $button.attr('tabIndex', 0);

        if (!$('.no--panel').length) {
          // On click event.
          $button.click(function (e) {
            e.preventDefault();

            $panel.slideDown(300).addClass('hidden');
            $('#button--wrapper-2').fadeOut(300);

            $('html, body').delay(300).animate({
              scrollTop: $panel.position().top
            }, 200);
          });

          // On press of enter key event.
          $button.keyup(function (e) {
            e.preventDefault();

            if (e.keyCode == 13) {
              $panel.slideDown(300);
              $('#button--wrapper-2').fadeOut(300);

              $('html, body').delay(300).animate({
                scrollTop: $panel.position().top
              }, 200);
            }
          });
        }
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 * Behavior for chart accordion slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccFilterAccordion = {
    attach: function attach(context, settings) {
      once('rmccFilterAccordion', '.view--header', context).forEach(function (elem) {

        var $button = $('.filter--title', $(elem)),
            $panel = $('.filter--content', $(elem));

        $button.attr('tabIndex', 0);
        $panel.hide();

        // On click event.
        $button.on('click', function (e) {
          $(e.currentTarget).parent().toggleClass('open');
          $(e.currentTarget).next().slideToggle();
        });

        // On press of enter key event.
        $button.keyup(function (e) {
          if (e.keyCode == 13) {
            $(e.currentTarget).parent().toggleClass('open');
            $(e.currentTarget).next().slideToggle();
          }
        });
      });

      // Accordion with checkboxes (View Events)
      if ($('.facets-checkboxes', context).length > 0 || $('.node--type-event .webform', context).length > 0) {
        var $buttonCheckbox = $('.filter--content h3, .node--type-event .webform .paragraph--title', context);

        $buttonCheckbox.on('click', function (e) {
          var $this = $(e.currentTarget);
          $this.toggleClass('open');
          $this.siblings('.facets-checkboxes, .node--type-event .webform--wrapper').toggleClass('hidden');
        });

        $('.view--filters__button').on('click', function (e) {
          var $this = $(e.currentTarget);
          $this.siblings('.view--filters__container').toggleClass('open');
        });
      }

      /*
      * Reset filters button.
      * Show button after filtering.
      * Reload page on button click.
      */
      var $originalUrl = window.location.origin + window.location.pathname;
      var $resetBtn = $('.view--filters__reset', context);

      if (window.location.href !== $originalUrl) {
        $resetBtn.addClass('show');
      }
      $resetBtn.on('click', function () {
        window.location.href = $originalUrl;
      });

      /* Auto submit radio buttons*/
      var $radioBtn = $('.view-events .form-radio', context);
      var $submitBtn = $('.view-events .bef-exposed-form .form-submit', context);

      $radioBtn.on('change', function () {
        $submitBtn.trigger('click');
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 * Behavior for gallery slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccGallerySLice = {
    attach: function attach(context, settings) {
      once('rmccGallerySLiceBehavior', '.gallery-slice', context).forEach(function (elem, i) {

        var $sliderFor = $('.gallery-slice__slider--for', $(elem)),
            $sliderNav = $('.gallery-slice__slider--nav', $(elem));

        $sliderFor.addClass('slider-for-' + i);
        $sliderNav.addClass('slider-nav-' + i);

        $sliderFor.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav-' + i,
          adaptiveHeight: false
        });

        $sliderNav.slick({
          slidesToScroll: 0,
          asNavFor: '.slider-for-' + i,
          dots: false,
          focusOnSelect: true,
          centerMode: true,
          variableWidth: true
        });
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 * General behaviours
 */
Drupal.behaviors.rmccMisc = {
  attach: function attach(context, settings) {
    if ($('.manual-address', context).length !== 0) {
      return;
    }
    $(document).on('click', 'a:not(.js-toggle-star-found)', function (event) {
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 50
      }, 500);
    });
  }
};
'use strict';

/**
 * Behavior for navigational block slice
 */
Drupal.behaviors.rmccNavigationalBLocksSlice = {
  attach: function attach(context, settings) {
    once('rmccNavigationalBLocksSLiceBehavior', '.paragraph--type--navigational-blocks-slice', context).forEach(function (elem) {

      // Set equal height for blocks
      // Better using imageloaded instead of window load
      $(window).on('load', function () {
        Drupal.rmcc.util.equalheight($('.navigational-blocks > article', $(elem)));
      });

      $(window).on('resize', function () {
        Drupal.rmcc.util.equalheight($('.navigational-blocks > article', $(elem)));
      });
    });
  }
};
'use strict';

/**
 * Behaviors for header handheld tabs
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccHandheldTabs = {
    attach: function attach(context, settings) {
      once('rmccTabsBehavior', '.page-header--handheld', context).forEach(function () {

        // Cache util elements
        var $tabsContext = $('.handheld-layout__tabs'),
            $tabNav = $(' > ul', $tabsContext),
            $tabNavItems = $('> li', $tabNav);

        $tabsContext.tabs({
          active: false,
          collapsible: true,
          show: { effect: "slideDown", duration: 300 },
          hide: { effect: "slideUp", duration: 300 },
          activate: function activate(event, ui) {

            // If there are active tabs set disabled classes for styling purposes else remove
            if ($('> li.ui-state-active', $tabNav).length) {
              $tabNavItems.each(function (i, elem) {
                $(elem).addClass('disabled');
              });
              $(ui.newTab).removeClass('disabled');

              // If it's search tab focus on text field
              if ($(ui.newTab).hasClass('handheld-tabs__nav-item--search')) {
                $('.form-text', $(ui.newPanel)).focus();
              }
            } else {
              $tabNavItems.each(function (i, elem) {
                $(elem).removeClass('disabled');
              });
            }
          }
        });
      });
    }
  };

  /**
   * Behaviors for search block
   */
  Drupal.behaviors.rmccHeaderSearch = {
    attach: function attach(context, settings) {
      once('rmccHeaderSearchBehavior', '.block-header-search-form', context).forEach(function () {

        var $context = $('.block-header-search-form'),
            $revealer = $('.header-search__reaveler', $context),
            $form = $('form', $context),
            $searchInput = $('.form-item-search-stories input', $form);

        $searchInput.attr('placeholder', 'Search');

        $revealer.on('click', function (e) {
          $form.toggleClass('active');
          $revealer.toggleClass('close');
          $form.toggle();
          $searchInput.focus();
        });
      });
    }
  };
})(Drupal, jQuery, once);
'use strict';

/**
 * Scrolling Effects JS.
 *
 */
(function ($) {
  Drupal.behaviors.scrollingEffects = {
    attach: function attach(context) {
      var $scrollInComponent = $('.js-scroll-in', context);
      var $progressOnePage = $('.page-node-type-progress-one-page');
      if (!$scrollInComponent.length || !$progressOnePage.length) {
        return false;
      }

      $scrollInComponent.each(function (index, component) {
        var $component = $(component, context);
        var topOfElement = $component.offset().top;
        var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();

        $component.addClass('scroll-in');

        if (bottomOfScreen > topOfElement) {
          $component.addClass('scroll-in--scrolled-to');
        }

        if ($(window).width() > 760) {
          $(window).on('scroll', function () {
            // Add class
            $component = $(component, context);
            topOfElement = $component.offset().top;
            bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
            if (bottomOfScreen > topOfElement) {
              setTimeout(function () {
                $component.addClass('scroll-in--scrolled-to');
              }, 250);
            }
            if ($(window).scrollTop() > 140) {
              $('.page-header').addClass('sticky');
            } else {
              $('.page-header').removeClass('sticky');
            }
          });
        }
      });
    }
  };
})(jQuery);
"use strict";

try {
  Typekit.load({ async: true });
} catch (e) {}
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * RMCC utility functions
 */
Drupal.rmcc.util = {

  /**
   * Get current viewport
   * @returns {{w: number, h: number}}
   */
  viewport: function viewport() {
    return {
      w: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      h: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
  },


  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  scrollPosition: function scrollPosition() {
    return {
      x: self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
      y: self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
  },


  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  disableScroll: function disableScroll() {
    var $html = $('html');
    $html.data('scroll-position', this.scrollPosition()).css({
      overflow: 'hidden'
    });
    window.scrollTo(0, this.scrollPosition().y);
  },


  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  enableScroll: function enableScroll() {
    $('html').removeAttr('style');
    if ((typeof scrollPosition === 'undefined' ? 'undefined' : _typeof(scrollPosition)) === 'object') {
      window.scrollTo(0, scrollPosition.y);
    }
  },


  /**
   * Create the given css rule in the document head
   *
   * This is handy to move inline styles into the head section
   * enhancing markup readability and devtools performance
   *
   * @param id
   * @param cssRule
   */
  style: function style(id, cssRule) {
    // If style tag doesn't exist yet create it
    if (!$('#' + id, 'head').size()) {
      $('head').append('<style id="' + id + '"></style>');
    }

    // Append style
    $('#' + id, 'head').html(cssRule);
  },


  /**
   * Set equal height to given elements
   * @param container
   */
  equalheight: function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        currentDiv = 0,
        rowDivs = [],
        $el = void 0,
        topPosition = 0;

    $(container).each(function () {

      $el = $(this);
      $($el).height('auto');
      topPosition = $el.position().top;

      if (currentRowStart != topPosition) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }
};})(jQuery, Modernizr, Drupal, drupalSettings);